const IPV4_PRIVATE_RANGES = [
  /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
  /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/,
  /^192\.168\.\d{1,3}\.\d{1,3}$/,
  /^127\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
  /^169\.254\.\d{1,3}\.\d{1,3}$/,
];

const isIpv6LinkLocal = hostname => /^fe[89ab][0-9a-f]:/i.test(hostname);
const isIpv6UniqueLocal = hostname => /^f[cd][0-9a-f]{2}:/i.test(hostname);
const isIpv6Loopback = hostname => hostname === '::1';

const isPrivateOrInternalHost = hostname => {
  if (!hostname) return false;

  const normalizedHostname = hostname.toLowerCase();

  if (normalizedHostname === 'localhost') return true;
  if (
    normalizedHostname.endsWith('.local') ||
    normalizedHostname.endsWith('.internal')
  ) {
    return true;
  }

  if (IPV4_PRIVATE_RANGES.some(range => range.test(normalizedHostname))) {
    return true;
  }

  if (
    isIpv6Loopback(normalizedHostname) ||
    isIpv6LinkLocal(normalizedHostname) ||
    isIpv6UniqueLocal(normalizedHostname)
  ) {
    return true;
  }

  return false;
};

export default isPrivateOrInternalHost;
